import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Button,
  Dialog,
  DialogContent,
  useMediaQuery,
  CircularProgress,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Field, getFormSyncErrors, getFormValues, reduxForm } from "redux-form";
import { renderTextField } from "components/FormFields/FieldTypes";
import { Required, emailValidator } from "components/FormFields/validators";
import { connect } from "react-redux";
import { homeActions, gaugeActions } from "actions";

const SendEmailMessagePopUp = (props) => {
  const {
    showSendEmailMessage,
    onCancel,
    formErrors,
    formValues,
    sendEmailMessage,
    brandDetailsNew,
    genericDetails,
    sendEmailMessageInfo,
    resetSendEmailInfo,
    showTextCoupon = false,
    updateGTMDataLayer,
    organizationInfo,
    couponData = null,
    fromSendSavinsgPOS = false,
    getBrandDetailsNew,
    productType = null,
    getGenericDetails,
    sendEmailMessageInfoIsProgress,
    fromBranded = false,
    autoSubmit = false,
    autoSubmitData = null,
  } = props;

  const theme = useTheme();

  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const matchesMinWidth = useMediaQuery("(max-width:600px)");

  const [triggerCopay, setTriggerCopay] = useState(false);

  const isPOSTemplate =
    organizationInfo?.type?.toLowerCase() === "p" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";

  const defaultInsuranceId = localStorage.getItem("defaultInsuranceId");
  const storedZipData = JSON.parse(localStorage.getItem("storedZipData"));

  const onSubmitPopUpData = async () => {
    if (autoSubmit) {
      sendEmailMessage({ ...autoSubmitData });
    } else {
      sendEmailMessage({
        ...formValues,
        adjudicationId: brandDetailsNew?.id || genericDetails?.id,
      });
    }
    updateGTMDataLayer({
      event: "Get_savings_share_email",
      page: "Copay Coupon Card",
      screen: "Copay Coupon Card",
      screen_referrer: "Copay Coupon Card",
      ...formValues,
      adjudicationId: brandDetailsNew?.id || genericDetails?.id,
    });
  };

  useEffect(() => {
    if (autoSubmit && autoSubmitData) {
      onSubmitPopUpData();
    }
  }, [autoSubmit]);

  useEffect(() => {
    if ((brandDetailsNew?.id || genericDetails?.id) && triggerCopay) {
      onSubmitPopUpData();
      setTriggerCopay(false);
    }
  }, [triggerCopay, brandDetailsNew, genericDetails]);

  const onSuccessDone = () => {
    setShowSuccess(false);
    onCancel();
  };

  const onFailedDone = () => {
    setShowFailure(false);
    onCancel();
  };

  useEffect(() => {
    resetSendEmailInfo();
    updateGTMDataLayer({
      event: "Get_savings_share_email_attempt",
      page: "Copay Coupon Card",
      screen: "Copay Coupon Card",
      screen_referrer: "Copay Coupon Card",
      adjudicationId: brandDetailsNew?.id || genericDetails?.id,
    });
    return () => {
      resetSendEmailInfo();
    };
  }, []);

  useEffect(() => {
    setShowFailure(false);
    setShowSuccess(false);
    if (
      sendEmailMessageInfo &&
      sendEmailMessageInfo.data &&
      sendEmailMessageInfo.success
    ) {
      setShowSuccess(true);
    }
    if (
      Object.keys(sendEmailMessageInfo).length &&
      !sendEmailMessageInfo.data &&
      !sendEmailMessageInfo.success
    ) {
      setShowFailure(true);
    }
  }, [sendEmailMessageInfo]);

  const renderLayout = () => {
    return (
      <DialogContent
        sx={{ padding: showTextCoupon ? "15px 24px 0px 24px" : "40px" }}
      >
        {sendEmailMessageInfoIsProgress ? (
          <div
            style={{
              height: "300px",
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <CircularProgress
              style={{ color: theme?.palette?.secondary?.main }}
            />
          </div>
        ) : !showSuccess && !showFailure ? (
          <form>
            <Box
              component="div"
              sx={{
                textAlign: "center",
                width: matchesMinWidth ? undefined : "500px",
                minHeight: !fromBranded ? "600px" : undefined,
                borderRadius: "20px",
              }}
            >
              {!fromBranded && !showTextCoupon && (
                <>
                  <Box mb={3}>
                    <Typography
                      variant="h2LatoBold"
                      sx={{
                        fontFamily: "Lato",
                        fontWeight: "bold",
                      }}
                    >
                      {isPOSTemplate
                        ? "Send this coupon by email"
                        : "Email me coupon to show pharmacist"}
                    </Typography>
                  </Box>
                  <Box mb={3} sx={{ fontWeight: 500 }}>
                    <Typography
                      variant="h2LatoMedium"
                      sx={{
                        fontWeight: 500,
                        fontSize: 16,
                        textAlign: "center",
                        color: "#607277",
                      }}
                    >
                      Enter the information to email this coupon:
                    </Typography>
                  </Box>
                </>
              )}
              <Box mb={4}>
                <Box mb={2}>
                  <Field
                    name="recipientEmail"
                    //isRequired
                    component={renderTextField}
                    label="Recipient’s email address"
                    validate={[Required, emailValidator]}
                  />
                </Box>
                <Box mb={2}>
                  <Field
                    name="recipientName"
                    component={renderTextField}
                    label="Recipient's name (optional)"
                  />
                </Box>
                <Box>
                  <Field
                    name="senderName"
                    component={renderTextField}
                    label="Sender's name (optional)"
                  />
                </Box>
              </Box>
              <Box mb={3} sx={{ textAlign: "center" }}>
                <Typography variant="h4LatoBold" sx={{ fontSize: "12px" }}>
                  By continuing to use this website, you agree to the <br />
                  Cuverd{" "}
                  <Box
                    component={Link}
                    to="/terms-and-conditions"
                    sx={
                      {
                        //textDecoration: "none",
                      }
                    }
                  >
                    <Typography
                      component={"span"}
                      sx={{ fontSize: "12px" }}
                      variant="h3LatoBoldNew"
                    >
                      Terms and Conditions
                    </Typography>
                  </Box>{" "}
                  and{" "}
                  <Box
                    component={Link}
                    to="/privacy-policy"
                    sx={
                      {
                        //textDecoration: "none",
                      }
                    }
                  >
                    <Typography
                      component={"span"}
                      sx={{ fontSize: "12px" }}
                      variant="h3LatoBoldNew"
                    >
                      Privacy Policy
                    </Typography>
                  </Box>{" "}
                </Typography>
              </Box>
              <Box mb={!fromBranded ? 4 : 0}>
                <Button
                  variant="large"
                  type="button"
                  onClick={() => {
                    if (fromSendSavinsgPOS) {
                      if (
                        couponData !== null &&
                        productType === "branded" &&
                        !brandDetailsNew?.id
                      ) {
                        getBrandDetailsNew({
                          offerId: couponData.offerId,
                          insuranceId: defaultInsuranceId,
                          zipCode: storedZipData?.zipCode,
                          quantity: couponData.quantity || 0,
                          productDetailId: couponData.productDetailId,
                          pharmacyLocationId: couponData.pharmacyLocationId,
                          prescriptionFlag: "N",
                        });
                      }
                      if (
                        couponData !== null &&
                        productType === "generic" &&
                        !genericDetails?.id
                      ) {
                        getGenericDetails({
                          productDetailId: couponData?.productDetailId,
                          offerId: couponData?.offerId,
                          insuranceId: defaultInsuranceId,
                          pbmPharmacyLocationId:
                            couponData?.pbmPharmacyLocationId,
                          zipCode:
                            couponData?.zipCode || storedZipData?.zipCode,
                          quantity: couponData?.quantity,
                          pbmProductDetailId: couponData?.pbmProductDetailId,
                          pharmacyGroupPbmId: couponData?.pharmacyGroupPbmId,
                          pbmId: couponData?.pbmId,
                        });
                      }
                      setTriggerCopay(true);
                    } else {
                      onSubmitPopUpData();
                    }
                  }}
                  disabled={Object.keys(formErrors).length ? true : false}
                  sx={{
                    backgroundColor: Object.keys(formErrors).length
                      ? "#e6e6e6"
                      : `${organizationInfo?.colorSchemeJson?.primaryButtonColor}`,
                    width: matchesMinWidth ? undefined : "100%",
                    fontSize: matchesMinWidth ? "14px" : undefined,
                    minWidth: matchesMinWidth ? "200px" : undefined,
                    color: Object.keys(formErrors).length
                      ? "#637276"
                      : `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor} !important`,
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: `${organizationInfo?.colorSchemeJson?.primaryButtonColor}`,
                    },
                  }}
                >
                  SEND COUPON
                </Button>
              </Box>
              {!fromBranded && (
                <Box
                  mx="auto"
                  sx={{ width: matchesMinWidth ? undefined : "100%" }}
                >
                  <Button
                    variant="text"
                    sx={{
                      width: matchesMinWidth ? undefined : "100%",
                      fontSize: matchesMinWidth ? "14px" : undefined,
                      minWidth: matchesMinWidth ? "200px" : undefined,
                      textDecoration: "underline",
                      //color: `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor} !important`,
                    }}
                    onClick={onCancel}
                  >
                    {/* <Typography
                variant="text2"
                sx={{
                  fontFamily: "Lato-Regular",
                  fontWeight: 600,
                  fontSize: 18,
                  textDecoration: "underline",
                }}
              > */}
                    CANCEL
                    {/* </Typography> */}
                  </Button>
                </Box>
              )}
            </Box>
          </form>
        ) : (
          <Box sx={{ textAlign: "center" }}>
            {showSuccess ? (
              <Box>
                <Box mb={4}>
                  <Typography variant="h2LatoBold">Coupon sent!</Typography>
                </Box>
                <Box mb={7}>
                  <Typography variant="h2LatoMedium">
                    You have successfully sent a coupon to{" "}
                    {formValues?.recipientEmail ||
                      autoSubmitData?.recipientEmail}
                    .
                  </Typography>
                </Box>
                {!fromBranded && (
                  <Box mb={3}>
                    <Button
                      variant="large"
                      sx={{
                        minWidth: { xs: "150px", sm: "100%", md: undefined },
                      }}
                      onClick={() => onSuccessDone()}
                    >
                      DONE
                    </Button>
                  </Box>
                )}
              </Box>
            ) : null}
            {showFailure ? (
              <Box>
                <Box mb={2}>
                  <Typography variant="h2LatoBold">Send Email Error</Typography>
                </Box>
                <Box mb={3}>
                  <Typography variant="h2LatoMedium">
                    {sendEmailMessage?.message}
                  </Typography>
                </Box>
                <Box mb={2}>
                  <Button variant="large" onClick={() => onFailedDone()}>
                    OK
                  </Button>
                </Box>
              </Box>
            ) : null}
          </Box>
        )}
      </DialogContent>
    );
  };

  return (
    <>
      {showTextCoupon ? (
        renderLayout()
      ) : (
        <Box>
          <Dialog
            open={showSendEmailMessage}
            className="app-dialog"
            onClose={onCancel}
            sx={{
              display: !autoSubmit
                ? "block"
                : showSuccess || showFailure
                ? "block"
                : "none",
            }}
          >
            {renderLayout()}
          </Dialog>
        </Box>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    formErrors: getFormSyncErrors("SEND_EMAIL_FORM")(state) || {},
    formValues: getFormValues("SEND_EMAIL_FORM")(state),
    sendEmailMessageInfo: state.sendEmailMessageInfo.data,
    brandDetailsNew: state.brandDetailsNew.data,
    genericDetails: state.genericDetails.data,
    organizationInfo: state.organizationInfo.data || {},
    sendEmailMessageInfoIsProgress: state.sendEmailMessageInfo.isProgress,
  };
};

const mapDispatchToProps = {
  sendEmailMessage: (params) => homeActions.sendEmailMessage(params),
  resetSendEmailInfo: () => homeActions.resetSendEmailInfo(),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
  getBrandDetailsNew: (params) => gaugeActions.getBrandDetailsNew(params),
  getGenericDetails: (params) => gaugeActions.getGenericDetails(params),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "SEND_EMAIL_FORM",
  })(SendEmailMessagePopUp)
);
